import { OpportunitiesListNew } from "@/components/opportunities/OpportunitiesListNew"
import { Opportunity } from "@/hooks/useOpportunitiesApi"

interface OpportunitiesResultsNewProps {
  opportunities: Opportunity[]
  totalCount: number
}

export const OpportunitiesResultsNew = ({
  opportunities,
  totalCount,
}: OpportunitiesResultsNewProps) => {
  return (
    <div className="flex-1">
      <div className="mb-6 flex items-center justify-between">
        <p className="text-lg text-muted-foreground">
          {totalCount} opportunities found
        </p>
        <select className="border rounded-md px-3 py-1.5">
          <option value="featured">Featured</option>
          <option value="newest">Newest</option>
          <option value="impact">Impact</option>
        </select>
      </div>
      <OpportunitiesListNew opportunities={opportunities} />
    </div>
  )
}
